module.exports = {
	components: {},
	props: ['id'],
	data() {
		return {
			errors: {},
			invalidRows: [],
			isLoading: false,
			skippingIsLoading: false,
			currentRowCounter: 1,
			currentRow: {
				data: {

				},
				errors: []
			},
			rowCount: null,
			pageIsLoading: true
		}
	},
	beforeMount() {
		this.loadInvalidRows();
	},
	methods: {
		reset()
		{
			$('#confirmationRestartModal').modal('toggle');
		},
		setRows(data)
		{
			this.invalidRows = data;
			this.rowCount = data.length;
			this.currentRow = data[0];
			this.skippingIsLoading = false;
			this.isLoading = false;
		}
	}
}